<template>
  <nt-template>
    <v-row dense justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card>
          <v-card-text class="text-center">
            <h3 class="text-h5 mt-4 mb-0 text-center">
              Carrinho
            </h3>
          </v-card-text>
          <v-card-text>
            <v-data-table :headers="headers" :items="cartItems" class="elevation-0">
              <template v-slot:item.amount="{ item }">
                {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.amount) }}
              </template>
              <template v-slot:item.courses="{ item }">
                {{ item.courses.map((item) => item.name).join(', ') }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="deleteCartItem(item)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <h3 class="text-center">Você ainda não adicionou nenhum curso no seu carrinho!</h3>
              </template>
              <template v-slot:footer>
                <div class="text-center">
                  <h3>Total: {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cartTotal) }}</h3>
                </div>
              </template>
            </v-data-table>

            <v-row dense class="pt-5" v-if="cartCount">
              <template v-if="isAuthenticated && cartItems">
                <v-col cols="12">
                  <payment type="SINGLE_PAYMENT" :items="cartItems"/>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12" lg="6">
                  <v-btn large depressed dark block color="green" @click="toLogin">
                    Prosseguir com o login
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-btn large depressed dark block color="green" @click="toRegister">
                    Cadastrar
                  </v-btn>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </nt-template>
</template>

<script>
import NtTemplate from '@/components/Utils/NtTemplate'
import Payment from '@/components/Payment/Index'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    NtTemplate,
    Payment
  },
  data () {
    return {
      headers: [
        { text: 'Nome', value: 'name', sortable: false },
        { text: 'Valor', value: 'amount', sortable: false },
        { text: 'Cursos', value: 'courses', sortable: false },
        { text: 'Ação', align: 'center', width: 120, value: 'action' }
      ]
    }
  },
  methods: {
    toLogin () {
      this.changeNextLogin('/cart')
      this.$router.push({ name: 'auth.login' })
    },
    toRegister () {
      this.changeNextLogin('/cart')
      this.$router.push({ name: 'auth.register' })
    },
    ...mapActions({
      deleteCartItem: 'Cart/deleteCartItem',
      changeNextLogin: 'App/changeNextLogin'
    })
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      cartItems: 'Cart/getCartItems',
      cartTotal: 'Cart/getCartTotal',
      cartCount: 'Cart/getCartCount'
    })
  }
}
</script>
